import { process as autoProcess } from "@microchip/scf-automodule-impl";
import { AppModel, DerivedData } from "@microchip/melody-automodule-interface";
import { ProcessorStages } from "@microchip/melody-automodule-interface/lib/src/InterfaceTypes";
import * as Processor from "@microchip/scf-common/lib/Processor";
import { getModuleConfigFromFile, getDerivedData } from "./getUserData";

export type LegacyProcessFunction = (
    initialModule: Processor.Module,
    stage: ProcessorStages,
) => Processor.ProcessedModule;

function createProcessor(
    getDerivedData: (dataModel?: AppModel) => DerivedData,
): LegacyProcessFunction {
    const hook = (
        initialModule: Processor.Module,
        stage: ProcessorStages,
    ): Processor.ProcessedModule => {
        const derivedDataGetter = (dataModel: AppModel): DerivedData => {
            return {
                getModuleConfig: getModuleConfigFromFile,
                ...getDerivedData(dataModel),
            };
        };
        return autoProcess(initialModule, stage, derivedDataGetter);
    };
    return hook;
}

export const process = createProcessor(getDerivedData);
